import React from 'react';
import { ResponsiveContainer, XAxis, Label, YAxis, BarChart } from 'recharts';

interface EmptyChartProps {
  height?: number;
  message?: string;
  marginTop?: number;
}

const EmptyChart: React.FC<EmptyChartProps> = ({ height = 400, message = 'Not Enough Data Available', marginTop }) => {
  return (
    <div style={{ width: '100%', height: `${height}px`, marginTop: marginTop }}>
      <ResponsiveContainer width='100%' height='100%'>
        <BarChart
          data={[
            { keyX: 'A', keyY: 100 },
            { keyX: 'B', keyY: 200 },
            { keyX: 'C', keyY: 300 },
            { keyX: 'D', keyY: 400 },
          ]}
          margin={{ top: 20, right: 30, left: 10, bottom: 40 }}
        >
          <XAxis dataKey={'keyX'} tick={{ fontSize: 10 }}>
            <Label value={message} position='center' style={{ transform: `translate(0px, -50%)` }} fill='#4E79A7' fontSize={14} />
          </XAxis>
          <YAxis dataKey={'keyY'} tick={{ fontSize: 10 }} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EmptyChart;
